import { render, staticRenderFns } from "./NewEditAutorizacaoPage.vue?vue&type=template&id=4d592b6c"
import script from "./NewEditAutorizacaoPage.vue?vue&type=script&lang=js"
export * from "./NewEditAutorizacaoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports